import React from 'react';
import { Redirect } from 'react-router-dom';
import EditUser from './components/AdminPanel/EditUser';
import EditVisualisations from './components/Visualisations/EditVisualisation';
import CreateVisualisation from './components/Visualisations/CreateVisualisation';
import EditDashboard from './components/AdminDashboards/EditDashboard';
import DashboardPreview from './components/AdminDashboards/DashboardPreview';
import CreateWorkspace from './components/WorkspaceConfiguration/createWorkspace';
import UpdateWorkspace from './components/WorkspaceConfiguration/updateWorkspace';
import SeverityRules from './components/SeverityRules';
import AddEditSeverityRule from './components/SeverityRules/AddEditSeverityRule';

// your components
const InfraView = React.lazy(() => import('./components/Infrastructure/InfraView'));
const MonitoringDashboard = React.lazy(() =>
  import('./components/Monitoring/MonitoringDashboard')
);
const InventoryDashBoard = React.lazy(() => import('./components/Inventory/Inventory'));
const InfraTopolgy = React.lazy(() => import('./components/InfraTopology'));
const RackView = React.lazy(() => import('./components/RackView'));
const PerformanceManagement = React.lazy(() => import('./components/PerformanceManagement'));
const Impact = React.lazy(() => import('./components/Impact'));
const MissingPage = React.lazy(() => import('./pages/PageNotFound'));
const Dashboard = React.lazy(() => import('./components/Dashboard'));
const ChangeRequest = React.lazy(() =>
  import('./components/ChangeRequest/ChangeRequest')
);
const Incidents = React.lazy(() => import('./components/Incidents/Incidents'));
const AdminPanel = React.lazy(() => import('./components/AdminPanel'));
//const RespDashboard = React.lazy(() => import('./components/LayOuts/Dashboard'));
const RespDashboard = React.lazy(() => import('./components/LayOuts/DynamicDashBoard'));
const JsonFormInputsCustom = React.lazy(() =>
  import('./components/JsonFormInputsCustom')
);
const Visualisations = React.lazy(() => import('./components/Visualisations'));
const AdminDashboards = React.lazy(() => import('./components/AdminDashboards'));
const D3BarChart = React.lazy(() => import('./components/D3BarChart'));
const MetricsDashboard = React.lazy(() => import('./components/MetricsKPIDashboard'));
const JobConfiguration = React.lazy(() => import('./components/JobConfiguration'));
const AddEditJobConfiguration = React.lazy(() =>
import('./components/JobConfiguration/AddEditJobConfiguration')
);
const WorkspaceConfiguration = React.lazy(() => import('./components/WorkspaceConfiguration'));

//import Infastructure from "./pages/Infastructure";

const ROUTEURLS = {
  default: '/',
  monitoring: '/monitoring',
  inventory: '/inventory',
  dashboardwithcust: '/dashboard/:custId/:siteid/monitoring',
  vnfView: '/view/vnf',
  vmView: '/view/vm',
  csuView: '/view/shell/csu',
  nruView: '/view/shell/nru',
  easView: '/view/shell/eas',
  dcgwView: '/view/shell/dcgw',
  cmuView: '/view/shell/cmu',
  cpaView: '/view/shell/cpa',
  ssuView: '/view/shell/ssu',
  infraView: '/view/geo-map',
  infraMap: '/view/geo-map',
  infraTopology: '/view/infra-topology',
  impactView: '/view/infra-topology/:nodetype/:nodeId',
  dashboard: '/dashboard',
  changerequest: '/changerequest',
  incidents: '/incidents',
  rackview: '/rackview',
  performancemanagement: '/performanceManagement',
  adminPanel: '/admin-panel',
  editUser: '/admin-panel/edit-user/:user_login',
  respdashboard: '/respdashboard',
  jsonchemeaform: '/json-schema-from',
  visualisations: '/visualizations',
  editvisualisations: '/visualizations/edit-visualizations/:dashboard_id',
  newvisualisations: '/visualizations/new-visualizations',
  admindashboards: '/admin-dashboard',
  editdashboard: '/admin-dashboard/edit-dashboard/:dashboard_id',
  newdashboard: '/admin-dashboard/new-dashboard',
  dashboardpreview: '/dashboard-preview/:dashboard_id',
  metricsdashboard: '/metrics-dashboard/:node_id',
  //inventory: "/dashboard/inventory",
  //inventory: "/dashboard/inventory",
  respdashboard: '/respdashboard',
  jobConfiguration: '/job-configuration',
  addJobConfiguration: '/job-configuration/add',
  editJobConfiguration: '/job-configuration/edit/:jobId',
  severityRules: '/severity-rules',
  addSeverityRule: '/severity-rules/add',
  editSeverityRule: '/severity-rules/edit/:severityRuleId',
  d3barchart: '/svg-bar-graph',
  workspaceconfiguration: '/workspace-config',
  createworkspace: '/workspace-config/new-workspace',
  editworkspace: '/workspace-config/edit-workspace'
};
const nonAdminRoutes = [
  {
    path: ROUTEURLS.default,
    name: 'Home',
    Component: (props) => <Redirect to={ROUTEURLS.infraView} />
  },
  {
    path: ROUTEURLS.monitoring,
    name: 'Monitoring',
    Component: (props) => <MonitoringDashboard {...props} />
  },
  {
    path: ROUTEURLS.inventory,
    name: 'Inventory',
    Component: (props) => <InventoryDashBoard {...props} />
  },
  {
    path: ROUTEURLS.changerequest,
    name: 'Change Request',
    Component: (props) => <ChangeRequest {...props} />
  },
  {
    path: ROUTEURLS.incidents,
    name: 'Incidents',
    Component: (props) => <Incidents {...props} />
  },
  {
    path: ROUTEURLS.vnfView,
    name: 'Vnf View',
    Component: (props) => <MissingPage {...props} />
  },
  {
    path: ROUTEURLS.vmView,
    name: 'Vm View',
    Component: (props) => <MissingPage {...props} />
  },
  {
    path: ROUTEURLS.csuView,
    name: 'Csu View',
    Component: (props) => <MissingPage {...props} />
  },
  {
    path: ROUTEURLS.nruView,
    name: ' Nru View',
    Component: (props) => <MissingPage {...props} />
  },
  {
    path: ROUTEURLS.infraMap,
    name: 'Geo Map',
    Component: (props) => <InfraView {...props} />
  },
  {
    path: ROUTEURLS.infraTopology,
    name: 'Infra Topology',
    Component: (props) => <InfraTopolgy {...props} />
  },
  {
    path: ROUTEURLS.rackview,
    name: 'Rack View',
    Component: (props) => <RackView {...props} />
  },
  {
    path: ROUTEURLS.performancemanagement,
    name: 'Performance Management',
    Component: (props) => <PerformanceManagement {...props} />
  },
  {
    path: ROUTEURLS.impactView,
    name: 'Impact View',
    Component: (props) => <Impact {...props} />
  },
  {
    path: ROUTEURLS.respdashboard,
    name: 'dashboard layout',
    Component: (props) => <RespDashboard />
  },
  {
    path: ROUTEURLS.jsonchemeaform,
    name: 'Json Form Inputs Custom',
    Component: (props) => <JsonFormInputsCustom />
  },
  {
    path: ROUTEURLS.dashboardpreview,
    name: 'Dashboard Preview',
    Component: (props) => <DashboardPreview {...props}/>
  },
  {
    path: ROUTEURLS.d3barchart,
    name: 'B3 Bar Chart',
    Component: (props) => <D3BarChart />
  },
  {
    path: ROUTEURLS.metricsdashboard,
    name: 'Metrics KPI Dashboard',
    Component: (props) => <MetricsDashboard />
  },
  {
    path: ROUTEURLS.severityRules,
    name: 'Severity Rules',
    Component: (props) => <SeverityRules {...props} />
  }
];

const adminRoutes = [
  {
    path: ROUTEURLS.default,
    name: 'Home',
    Component: (props) => <Redirect to={ROUTEURLS.infraView} />
  },
  {
    path: ROUTEURLS.adminPanel,
    name: 'Admin Panel',
    Component: (props) => <AdminPanel {...props} />
  },
  {
    path: ROUTEURLS.editUser,
    name: 'Edit User',
    Component: (props) => <EditUser {...props} />
  },
  {
    path: ROUTEURLS.monitoring,
    name: 'Monitoring',
    Component: (props) => <MonitoringDashboard {...props} />
  },
  // {
  //   path: ROUTEURLS.dashboard,
  //   name: 'Dashboard',
  //   Component: (props) => <RespDashboard {...props} />
  // },
  {
    path: ROUTEURLS.inventory,
    name: 'Inventory',
    Component: (props) => <InventoryDashBoard {...props} />
  },
  {
    path: ROUTEURLS.changerequest,
    name: 'Change Request',
    Component: (props) => <ChangeRequest {...props} />
  },
  {
    path: ROUTEURLS.incidents,
    name: 'Incidents',
    Component: (props) => <Incidents {...props} />
  },
  {
    path: ROUTEURLS.rackview,
    name: 'Rack View',
    Component: (props) => <RackView {...props} />
  },
  {
    path: ROUTEURLS.performancemanagement,
    name: 'Performance Management',
    Component: (props) => <PerformanceManagement {...props} />
  },
  {
    path: ROUTEURLS.vnfView,
    name: 'Vnf View',
    Component: (props) => <MissingPage {...props} />
  },
  {
    path: ROUTEURLS.vmView,
    name: 'Vm View',
    Component: (props) => <MissingPage {...props} />
  },
  {
    path: ROUTEURLS.csuView,
    name: 'Csu View',
    Component: (props) => <MissingPage {...props} />
  },
  {
    path: ROUTEURLS.nruView,
    name: ' Nru View',
    Component: (props) => <MissingPage {...props} />
  },
  {
    path: ROUTEURLS.infraMap,
    name: 'Geo Map',
    Component: (props) => <InfraView {...props} />
  },
  {
    path: ROUTEURLS.infraTopology,
    name: 'Infra Topology',
    Component: (props) => <InfraTopolgy {...props} />
  },
  {
    path: ROUTEURLS.impactView,
    name: 'Impact View',
    Component: (props) => <Impact {...props} />
  },
  {
    path: ROUTEURLS.respdashboard,
    name: 'dashboard layout',
    Component: (props) => <RespDashboard />
  },
  {
    path: ROUTEURLS.jsonchemeaform,
    name: 'Json Form Inputs Custom',
    Component: (props) => <JsonFormInputsCustom />
  },
  {
    path: ROUTEURLS.visualisations,
    name: 'visualizations',
    Component: (props) => <Visualisations />
  },
  {
    path: ROUTEURLS.editvisualisations,
    name: 'Edit visualizations',
    Component: (props) => <EditVisualisations />
  },
  {
    path: ROUTEURLS.newvisualisations,
    name: 'New visualizations',
    Component: (props) => <CreateVisualisation />
  },
  {
    path: ROUTEURLS.admindashboards,
    name: 'Admin Dashboard',
    Component: (props) => <AdminDashboards />
  },
  {
    path: ROUTEURLS.editdashboard,
    name: 'Edit Dashboard',
    Component: (props) => <EditDashboard />
  },
  {
    path: ROUTEURLS.newdashboard,
    name: 'New Dashboard',
    Component: (props) => <EditDashboard />
  },
  {
    path: ROUTEURLS.dashboardpreview,
    name: 'Dashboard Preview',
    Component: (props) => <DashboardPreview {...props}/>
  },
  {
    path: ROUTEURLS.d3barchart,
    name: 'B3 Bar Chart',
    Component: (props) => <D3BarChart />
  },
  {
    path: ROUTEURLS.metricsdashboard,
    name: 'Metrics KPI Dashboard',
    Component: (props) => <MetricsDashboard />
  },
  {
    path: ROUTEURLS.jobConfiguration,
    name: 'Job Configuration',
    Component: (props) => <JobConfiguration {...props} />
  },
  {
    path: ROUTEURLS.addJobConfiguration,
    name: 'New Job Configuration',
    Component: (props) => <AddEditJobConfiguration {...props} />
  },
  {
    path: ROUTEURLS.editJobConfiguration,
    name: 'Edit Job Configuration',
    Component: (props) => <AddEditJobConfiguration {...props} />
  },
  {
    path: ROUTEURLS.workspaceconfiguration,
    name: 'Workspace Configuration',
    Component: (props) => <WorkspaceConfiguration {...props} />
  },
  {
    path: ROUTEURLS.createworkspace,
    name: 'New Workspace',
    Component: (props) => <CreateWorkspace {...props} />
  },
  {
    path: ROUTEURLS.editworkspace,
    name: 'Edit Workspace',
    Component: (props) => <UpdateWorkspace {...props} />
  },
  {
    path: ROUTEURLS.severityRules,
    name: 'Severity Rules',
    Component: (props) => <SeverityRules {...props} />
  },
  {
    path: ROUTEURLS.addSeverityRule,
    name: 'New Severity Rule',
    Component: (props) => <AddEditSeverityRule {...props} />
  },
  {
    path: ROUTEURLS.editSeverityRule,
    name: 'Edit Severity Rule',
    Component: (props) => <AddEditSeverityRule {...props} />
  }
  //   {
  //     //path: ROUTEURLS.dashboardwithcust,
  //     name: 'route not found',
  //     Component: (props) => <MissingPage />
  //   }
];
export { nonAdminRoutes, adminRoutes, ROUTEURLS };
